import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Avatar,
  Tooltip,
  FormHelperText,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_USER } from "../../Schema/User";
import { translateLauguage } from "../../Function/Translate";
import CropImageFile from "../CropImage/CropImageFile";
// import { SelectEmployee } from "../Include/DynamicSelect";
import { UPDATE_GROUP_FEE } from "../../Schema/GroupFee";
import {
  SelectShift,
  SelectProgramme,
  SelectClassGroup,
} from "../Include/DynamicSelect";

export default function UpdateGroupFee({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [programmeVal, setProgrammeVal] = useState({ id: "", title: "" });
  const [shiftVal, setShiftVal] = useState({ id: "", title: "" });

  const [updateGroupFee] = useMutation(UPDATE_GROUP_FEE, {
    onCompleted: ({ updateGroupFee }) => {
      setLoading(false);
      // console.log("updateGroupFee::", updateGroupFee);
      if (updateGroupFee?.status === true) {
        setAlert(true, "success", updateGroupFee?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateGroupFee?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const Validate = Yup.object().shape({
    incomeType: Yup.string().required("require!"),
    groupFeeName: Yup.string().required("required!"),
    programId: Yup.string().required("required!"),
    shiftId: Yup.string().required("required!"),
    academicYearCost: Yup.number()
      .min(0, "academic year cost must be more than 0!")
      .required("required!"),
    academicTermCost: Yup.number()
      .min(0, "academic term, cost must be more than 0!")
      .required("required!"),
    quarterCost: Yup.number()
      .min(0, "quarter cost must be more than 0!")
      .required("required!"),
    monthCost: Yup.number()
      .min(0, "month cost must be more than 0!")
      .required("required!"),
    note: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      incomeType: "Tuition",
      groupFeeName: "",
      programId: "",
      shiftId: "",
      academicYearCost: 0,
      academicTermCost: 0,
      quarterCost: 0,
      monthCost: 0,
      note: "",
    },

    validationSchema: Validate,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      updateGroupFee({
        variables: {
          id: editData?._id,
          input: {
            ...values,
          },
        },
      });
    },
  });

  useEffect(() => {
    if (programmeVal?.id) {
      setFieldValue("programId", programmeVal?.id);
    } else {
      setFieldValue("programId", "");
    }
  }, [programmeVal?.id]);

  useEffect(() => {
    if (shiftVal?.id) {
      setFieldValue("shiftId", shiftVal?.id);
    } else {
      setFieldValue("shiftId", "");
    }
  }, [shiftVal?.id]);
 
  useEffect(() => {
    if (editData) {
      setFieldValue("groupFeeName", editData?.groupFeeName);
      setFieldValue("programId", editData?.programId);
      setProgrammeVal({
        id: editData?.programId,
        title: editData?.programName,
      });
      // setFieldValue("classGroup", editData?.classGroupId);
      // setClassGroupVal({
      //   id: editData?.classGroupId,
      //   title: editData?.classGroupName,
      // });
      setFieldValue("incomeType", editData?.incomeType ? editData?.incomeType : "Tuition");
      setFieldValue("shiftId", editData?.shiftId);
      setShiftVal({ id: editData?.shiftId, title: editData?.shiftName });
      setFieldValue("academicYearCost", editData?.academicYearCost);
      setFieldValue("academicTermCost", editData?.academicTermCost);
      setFieldValue("quarterCost", editData?.quarterCost);
      setFieldValue("monthCost", editData?.monthCost);
      setFieldValue("note", editData?.note ? editData?.note : "");
    }
    if (editData?.programId === null) {
      setProgrammeVal({ id: "", title: "" });
    }
  }, [open]);

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Create group fee</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6}>
                <Typography className="field-title">Income type</Typography>
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={values?.incomeType}
                    onChange={(e) =>
                      setFieldValue("incomeType", e.target.value)
                    }
                  >
                    <MenuItem value="Tuition">Tuition</MenuItem>
                    <MenuItem value="General Programme">General Programme</MenuItem>
                    <MenuItem value="Summer Class">Summer Class</MenuItem>
                    <MenuItem value="Premium Class">Premium Class</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Group fee name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="text"
                  placeholder="group fee name"
                  {...getFieldProps("groupFeeName")}
                  error={Boolean(touched.groupFeeName && errors.groupFeeName)}
                  helperText={touched.groupFeeName && errors.groupFeeName}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  Select programme
                </Typography>
                <SelectProgramme
                  selectedVal={programmeVal}
                  setSelectedVal={setProgrammeVal}
                />
                {!!errors.programId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.programId}
                  </FormHelperText>
                )}
              </Grid>
              {/* <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  Select class group
                </Typography>
                <SelectClassGroup
                  selectedVal={classGroupVal}
                  setSelectedVal={setClassGroupVal}
                  disabled={programmeVal?.id ? false : true}
                  programmeId={programmeVal?.id}
                />
              </Grid> */}
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Select shift</Typography>
                <SelectShift
                  selectedVal={shiftVal}
                  setSelectedVal={setShiftVal}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className="field-title">
                  Academic year cost
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        $
                      </InputAdornment>
                    ),
                    inputProps: {
                      min: 0,
                    },
                  }}
                  {...getFieldProps("academicYearCost")}
                  error={Boolean(
                    touched.academicYearCost && errors.academicYearCost
                  )}
                  helperText={
                    touched.academicYearCost && errors.academicYearCost
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className="field-title">
                  Academic tern cost
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        $
                      </InputAdornment>
                    ),
                    inputProps: {
                      min: 0,
                    },
                  }}
                  {...getFieldProps("academicTermCost")}
                  error={Boolean(
                    touched.academicTermCost && errors.academicTermCost
                  )}
                  helperText={
                    touched.academicTermCost && errors.academicTermCost
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className="field-title">Quarter cost</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        $
                      </InputAdornment>
                    ),
                    inputProps: {
                      min: 0,
                    },
                  }}
                  {...getFieldProps("quarterCost")}
                  error={Boolean(touched.quarterCost && errors.quarterCost)}
                  helperText={touched.quarterCost && errors.quarterCost}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className="field-title">Month cost</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        $
                      </InputAdornment>
                    ),
                    inputProps: {
                      min: 0,
                    },
                  }}
                  {...getFieldProps("monthCost")}
                  error={Boolean(touched.monthCost && errors.monthCost)}
                  helperText={touched.monthCost && errors.monthCost}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Note</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="text"
                  placeholder="note"
                  {...getFieldProps("note")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
